var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[(_vm.notificationPreviewContent)?_c('system-notification',{attrs:{"content":_vm.notificationPreviewContent},on:{"close":_vm.closeModalNotification}}):_c('div',{staticClass:"pa-4"},[_c('p',[_vm._v("No se encontró la notificación seleccionada.")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }